import React, { useEffect, useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import '../CreateProduct.css';
import {
    makeStyles, Paper, Button, CircularProgress
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import clsx from 'clsx';
import classNames from 'classnames';
import { convertToRaw, EditorState, RichUtils } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import CustomAlert from '../../CustomAlert';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { dateFormatter, sleep } from '../../Models/CommonFunc'
import { Helmet } from 'react-helmet';
import { createPartyDocument } from '../../../Backend/firebase/party';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function CreateParty() {
    const { register, handleSubmit, errors, reset } = useForm();
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const onSubmit = async (data) => {
        setIsLoading(true);
        var newParty = {};
        newParty.userId = userData.uid;
        newParty.PartyName = data.PartyName;
        newParty.PartyType = data.PartyType;
        newParty.Address = data.Address;
        newParty.City = data.City;
        newParty.Pincode = data.Pincode;
        newParty.MobileNumber = data.MobileNumber;
        newParty.Email = data.Email;
        newParty.DrugLicense = data.DrugLicense;
        newParty.GSTNo = data.GSTNo;
        newParty.FSSAINo = data.FSSAINo;
        newParty.OverDue = data.OverDue;
        newParty.LastPayment = data.LastPayment;
        try {
            var party = createPartyDocument(newParty);
            if (party) {
                setNotificationMessage('Party Added successfully.');
                setOpenNotify(true);
                setAlertType('success');
                reset();
                setIsLoading(false);
                setTimeout(routeToPages, 2000);
            } else {
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-party');
            }
        }  catch (error) {
            console.error(error);
            setNotificationMessage('Something went wrong, Please try again later!!');
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
            history.push('/retailer/create-party');
        }
    };

    const routeToPages = () => {
        window.location.pathname = '/retailer/parties';
    }


    return (
        <>
            <div className="createProduct mt-2">
                <Helmet>
                    <meta name="description" content="Creating New Party page." />
                    <title>Create New Party | Kaipsool Pharmatech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                Party Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.PartyName })}
                                    name="PartyName" autoComplete="none"
                                    ref={register({ required: 'Please enter Party Name!' })} />
                                <small className="form-text text-danger">{errors.PartyName && errors.PartyName.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Party Type <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.PartyType })} 
                                    aria-label="Default select example"
                                    name="PartyType" ref={register({
                                        required: 'Please select Party Type!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select Party Type!'
                                        }
                                    })} defaultValue="Select Party Type" >
                                    <option value={'Client'}>{'Client'}</option>
                                    <option value={'Vendor'}>{'Vendor'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.PartyType && errors.PartyType.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Mobile Number <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.MobileNumber })}
                                    name="MobileNumber" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter MobileNumber!' })} />
                                    <small className="form-text text-danger">{errors.MobileNumber && errors.MobileNumber.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Email <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Email })}
                                    name="Email" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Email!' })} />
                                    <small className="form-text text-danger">{errors.Email && errors.Email.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Address <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Address })}
                                    name="Address" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Address!' })} />
                                    <small className="form-text text-danger">{errors.Address && errors.Address.message}</small>
                            </div>
                            <div className="col-md-3 mb-2">
                                City <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.City })}
                                    name="City" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter City!' })} />
                                    <small className="form-text text-danger">{errors.City && errors.City.message}</small>
                            </div>
                            <div className="col-md-3 mb-2">
                                Pincode <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Pincode })}
                                    name="Pincode" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Pincode!' })} />
                                    <small className="form-text text-danger">{errors.Pincode && errors.Pincode.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Drug License
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="DrugLicense" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-4 mb-2">
                                GST No
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="GSTNo" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-4 mb-2">
                                FSSAI No
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="FSSAINo" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-6 mb-2">
                                Payment Over Due
                                <input type="number" className={classNames("form-control registerEmp__textbox")}
                                    name="OverDue" autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-6 mb-2">
                                Last Payment
                                <input type="number" className={classNames("form-control registerEmp__textbox")}
                                    name="LastPayment" autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-sm-12 text-right mt-2">
                                <div className="d-flex justify-content-center">
                                    <div className="p-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Add New Party'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Paper>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default CreateParty

